import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	assignSubtaskToEpicErrorFlagTitle: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card.assign-subtask-to-epic-error-flag-title',
		defaultMessage: 'You can’t add subtasks to epics',
		description:
			'The title of the error flag used to inform users why the drag-and-drop interaction is disabled, , as subtasks cannot be assigned to an epic.',
	},
	assignSubtaskToEpicErrorDescription: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card.assign-subtask-to-epic-error-description',
		defaultMessage:
			'Subtasks are automatically associated with the same epic as their parent issues. To associate a subtask with an epic, drag its parent issue to an epic in the panel.',
		description:
			'An error mesage to inform the user why the drag-and-drop operation is disabled, as subtasks cannot be assigned to an epic.',
	},
	genericAssignToEpicErrorFlagTitle: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card.generic-assign-to-epic-error-flag-title',
		defaultMessage: 'Issue can’t be added to epic',
		description:
			'Title for the generic error flag shown to the user whenever the backend returns an error',
	},
	assignSubtaskToEpicErrorDescriptionIssueTermRefresh: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card.assign-subtask-to-epic-error-description-issue-term-refresh',
		defaultMessage:
			'Subtasks are automatically associated with the same epic as their parent work item. To associate a subtask with an epic, drag its parent work item to an epic in the panel.',
		description:
			'An error mesage to inform the user why the drag-and-drop operation is disabled, as subtasks cannot be assigned to an epic.',
	},
	genericAssignToEpicErrorFlagTitleIssueTermRefresh: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card.generic-assign-to-epic-error-flag-title-issue-term-refresh',
		defaultMessage: 'Work item can’t be added to epic',
		description:
			'Title for the generic error flag shown to the user whenever the backend returns an error',
	},
});
